import { render } from "./TransactionLaw.vue?vue&type=template&id=fb4c0c0c&scoped=true"
import script from "./TransactionLaw.vue?vue&type=script&lang=js"
export * from "./TransactionLaw.vue?vue&type=script&lang=js"

import "./TransactionLaw.vue?vue&type=style&index=0&id=fb4c0c0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb4c0c0c"]])

export default __exports__